import { createFileRoute } from '@tanstack/react-router';
import { BoxesListPage } from '@/features/holders/boxes-list-page.js';

export const Route = createFileRoute('/_app/boxes/')({
  component: BoxesListPage,
});
